import React, { useMemo } from 'react';
import { 
  format, startOfMonth, endOfMonth, eachDayOfInterval, 
  startOfToday, isBefore, startOfDay, isSameDay, isAfter 
} from 'date-fns';
import CalendarDay from './CalendarDay';

const CalendarGrid = ({ currentMonth, startDate, endDate, blockedDatesSet, onDateClick }) => {
  const days = useMemo(() => {
    return eachDayOfInterval({
      start: startOfMonth(currentMonth),
      end: endOfMonth(currentMonth),
    });
  }, [currentMonth]);

  const today = useMemo(() => startOfToday(), []);

  // Determine if we are currently in the mode of selecting an end date
  const isSelectingEndDate = !!startDate && !endDate;

  return (
    <div className="grid grid-cols-7 border-t border-l border-brand-olive/5">
      {['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].map(day => (
        <div key={day} className="py-6 text-center text-[10px] font-black uppercase tracking-[0.2em] text-brand-olive/30 border-r border-b border-brand-olive/5 bg-brand-cream/20">
          {day}
        </div>
      ))}
      {days.map((day, idx) => {
        const dateStr = format(day, 'yyyy-MM-dd');
        const isBlocked = blockedDatesSet.has(dateStr);
        const isPastDate = isBefore(startOfDay(day), today);
        const isSelectedStart = startDate && isSameDay(day, startDate);
        const isSelectedEnd = endDate && isSameDay(day, endDate);
        const isBetween = startDate && endDate && isAfter(day, startDate) && isBefore(day, endDate);

        return (
          <CalendarDay
            key={dateStr}
            day={day}
            idx={idx}
            isBlocked={isBlocked}
            isPastDate={isPastDate}
            isSelectedStart={isSelectedStart}
            isSelectedEnd={isSelectedEnd}
            isBetween={isBetween}
            isSelectingEndDate={isSelectingEndDate}
            onClick={() => onDateClick(day)}
          />
        );
      })}
    </div>
  );
};

export default React.memo(CalendarGrid);